(function () {
    'use strict';

    var $ = window.jQuery;

    function Sharer() {
        this.setup();
    }

    Sharer.prototype.setup = function () {
        var $self = this;
        $(document).on('click', '[data-share]', function (e) {
            e.preventDefault();

            var $social = $(this).data('share'),
                $url = $(this).data('url') || encodeURIComponent(window.location.href);

            switch ($social) {
                case 'facebook':
                    $self.facebookShare($url);
                    break;
                case 'facebook-messenger':
                    $self.facebookMessengerShare($url);
                    break;
                case 'twitter':
                    $self.twitterShare($url);
                    break;
                case 'google':
                    $self.googlePlusShare($url);
                    break;
                case 'email':
                    $self.emailShare($url);
                    break;
            }

            return false;
        });
    };


    Sharer.prototype.twitterShare = function (url) {
        var title = encodeURIComponent(document.getElementsByTagName("title")[0].innerHTML);

        window.open('http://twitter.com/share?text=' + title + '&url=' + url, 'sharer', 'toolbar=1,status=1,menubar=1');
    };

    Sharer.prototype.facebookShare = function (url) {
        window.open('http://www.facebook.com/sharer.php?u=' + url, 'sharer', 'toolbar=1,status=1');
    };

    Sharer.prototype.facebookMessengerShare = function (url) {
        window.open('http://www.facebook.com/dialog/send?app_id=1889303811293489&link=' + url + '&redirect_uri=' + url)
    };

    Sharer.prototype.emailShare = function (url) {
        var title = encodeURIComponent(document.getElementsByTagName("title")[0].innerHTML);

        window.open('mailto:?&subject=' + title + '&body=' + title + ' ' + url);
    };

    Sharer.prototype.googlePlusShare = function (url) {
        window.open('https://plus.google.com/share?url=' + url, 'sharer', 'toolbar=1,status=1');
    };

    window.Sharer = Sharer;
}())
;